/**
 * Carousel Flickity
 * ======================================
 * - https://flickity.metafizzy.co/
 */

 import Flickity from "flickity";

 const SELECTOR = ".js-ProjectsCarousel";
 const SETTINGS = {
   cellAlign: "left",
   contain: true,
   groupCells: true,
   adaptiveHeight: true
 };

 class ProjectsCarousel {
   constructor() {
     this.elements = document.querySelectorAll(SELECTOR);

     if (!this.elements) {
       return false;
     }

     this.elements.forEach((el) => {
       this.init(el);
     });
   }

   init = (el) => {
     const obj = new Flickity(el, SETTINGS);

     obj.on( 'change', function( index ) {
       if(index == obj.slides.length - 1) {
        el.classList.add('flickity-end')
       } else {
        el.classList.remove('flickity-end')
       }
     });
   };
 }

 new ProjectsCarousel();
